import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message || "Email envoyé");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1E4D] flex items-center justify-center px-5 hero-grid">
      <div className="w-full max-w-md">
        <button onClick={() => navigate("/admin/login")} className="flex items-center gap-2 text-slate-300 hover:text-white text-sm mb-6 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Retour à la connexion
        </button>
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-8" data-testid="forgot-password-card">
          <Logo flagClass="h-9" textClass="text-2xl" />

          {sent ? (
            <div className="mt-6 text-center" data-testid="forgot-password-sent">
              <div className="mx-auto h-14 w-14 rounded-full bg-emerald-100 grid place-items-center">
                <CheckCircle2 className="h-8 w-8 text-emerald-600" />
              </div>
              <h1 className="font-display mt-4 text-xl font-bold text-slate-900">Vérifiez votre boîte mail</h1>
              <p className="text-sm text-slate-500 mt-2 leading-relaxed">
                Si un compte existe pour <strong>{email}</strong>, un lien pour définir votre mot de passe vient d'être envoyé. Le lien est valable 1 heure.
              </p>
              <Button onClick={() => navigate("/admin/login")} className="mt-6 w-full h-11 bg-[#0B1E4D] hover:bg-[#0a1840]">Retour à la connexion</Button>
            </div>
          ) : (
            <>
              <h1 className="font-display mt-6 text-2xl font-bold text-slate-900">Première connexion</h1>
              <p className="text-sm text-slate-500 mt-1">Saisissez votre email pour recevoir un lien de définition de mot de passe.</p>
              <form onSubmit={submit} className="mt-6 space-y-4" autoComplete="off">
                <div>
                  <Label className="text-slate-700 font-medium">Email</Label>
                  <Input className="mt-1.5" type="email" name="bc-forgot-email" placeholder="Votre adresse email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off" data-testid="forgot-email-input" required />
                </div>
                <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700 font-semibold" data-testid="forgot-submit-button">
                  {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Mail className="h-4 w-4 mr-2" /> Envoyer le lien</>}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
